module.exports = __webpack_public_path__ + "static/media/Visa.5a6315ed.svg";